import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-pause\"><rect width=\"32\" height=\"32\" rx=\"2\" fill=\"#fff\" fill-opacity=\".5\" /><path stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M11.75 9.75v12.5m8-12.5v12.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol